function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M135.196 78.944c1.197-3.685 6.411-3.685 7.608 0l1.307 4.022a6 6 0 005.706 4.146h4.228c3.875 0 5.486 4.958 2.352 7.236l-3.421 2.485a6 6 0 00-2.18 6.708l1.307 4.021c1.197 3.686-3.021 6.75-6.156 4.472l-3.42-2.485a6 6 0 00-7.054 0l-3.42 2.485c-3.135 2.278-7.353-.786-6.156-4.472l1.307-4.021a6 6 0 00-2.18-6.708l-3.421-2.486c-3.134-2.277-1.523-7.235 2.352-7.235h4.228a6 6 0 005.706-4.146l1.307-4.022zm-45 0c1.197-3.685 6.41-3.685 7.608 0l1.307 4.022a6 6 0 005.706 4.146h4.228c3.875 0 5.486 4.958 2.352 7.236l-3.421 2.485a6 6 0 00-2.18 6.708l1.307 4.021c1.197 3.686-3.021 6.75-6.156 4.472l-3.42-2.485a6 6 0 00-7.054 0l-3.42 2.485c-3.135 2.278-7.353-.786-6.156-4.472l1.307-4.021a6 6 0 00-2.18-6.708l-3.42-2.486c-3.135-2.277-1.524-7.235 2.35-7.235h4.229a6 6 0 005.706-4.146l1.307-4.022z",
  fill: "#FFB900",
  fillOpacity: 0.7,
  stroke: "#FF5520",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M111.5 95h10",
  stroke: "#FF5520",
  strokeWidth: 3,
  strokeLinecap: "round"
});

function SvgAccessories2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/accessories-2.9e4047b7.svg";
export { SvgAccessories2 as ReactComponent };